module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/inner-space/main-scene/main-scene.component.css
// module id = ./src/app/inner-space/main-scene/main-scene.component.css
// module chunks = main